import React, { FunctionComponent, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGetBackofficeUsersQuery } from 'services/exploreApi';
import { CommonHash } from 'app/types';
import styles from './Users.module.scss';
import Text from 'common/components/Text/Text';
import { logoutUser } from 'features/session/sessionSlice';
import { useAppDispatch } from 'app/hooks';
import { setProfileCompleted, setProfileProgress } from 'features/user/userSlice';
import Loader from 'common/components/Loader/Loader';
import Table from 'common/components/NewTable/NewTable';

const columns = [
  { name: 'id', header: 'ID', type: 'number', defaultWidth: 60 },
  {
    name: 'name',
    defaultFlex: 1,
    header: 'NAME',
  },
  {
    name: 'email',
    defaultFlex: 1,
    header: 'EMAIL',
  },
  {
    name: 'phone',
    defaultFlex: 1,
    header: 'PHONE',
  },
  {
    name: 'phone_country',
    defaultFlex: 1,
    header: 'PHONE COUNTRY',
  },
  {
    name: 'profile_completed',
    defaultFlex: 1,
    header: 'PROFILE COMPLETED',
    render: ({ value }: { value: boolean }) => {
      return (
        <i
          className={`${
            value
              ? `bi bi-check-circle-fill ${styles.greenIcon}`
              : `bi bi-x-circle-fill ${styles.redIcon}`
          }`}
        />
      );
    },
  },
  {
    name: 'preferences_filled',
    defaultFlex: 1,
    header: 'PREFERENCES FILLED',
    render: ({ value }: { value: boolean }) => {
      return (
        <i
          className={`${
            value
              ? `bi bi-check-circle-fill ${styles.greenIcon}`
              : `bi bi-x-circle-fill ${styles.redIcon}`
          }`}
        />
      );
    },
  },
  {
    name: 'total_applications',
    defaultFlex: 1,
    header: 'TOTAL APPLICATIONS',
  },
  {
    name: 'total_shortlisted',
    defaultFlex: 1,
    header: 'TOTAL SHORTLISTED',
  },
  {
    name: 'created_at',
    defaultFlex: 1,
    header: 'CREATED AT',
  },

  {
    name: 'action',
    defaultFlex: 1,
    header: 'ACTIONS',
    render: ({ data }: { data: CommonHash }) => {
      return (
        <div>
          <Link to={`/backoffice/users/${data.id}`}>
            <i className="bi bi-eye" />
          </Link>
        </div>
      );
    },
  },
];
const defaultFilterValue = [{ name: 'name', operator: 'contains', type: 'string', value: '' }];

const Users: FunctionComponent = () => {
  const [limit, setLimit] = useState(25);
  const [page, setPage] = useState(1);
  const [filterValue, setFilterValue] = useState(defaultFilterValue);
  const { data: users, isLoading } = useGetBackofficeUsersQuery({
    page_size: limit,
    page: page,
    query: JSON.stringify(filterValue),
  });
  const dispatch = useAppDispatch();
  dispatch(logoutUser());
  dispatch(setProfileCompleted(false));
  dispatch(setProfileProgress({}));

  if (isLoading) return <Loader />;

  return (
    <div className={styles.userIndex}>
      <Text size={30} weight={800} inlineStyle={{ marginBottom: '30px', marginLeft: '20px' }}>
        Users
      </Text>
      <Table
        columns={columns}
        data={users ? users.data : []}
        filters={filterValue}
        total={users?.meta.total || 0}
        limit={limit}
        setLimit={setLimit}
        page={page}
        setPage={setPage}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default Users;
